import React from 'react'
import {Util} from 'yougile-util'
import {EmojiText} from '@components/common/emoji-picker/emoji-picker'
import {Search} from '@extensions/search'

interface Props {
  text: string
  highlight: string
}

export const Highlight = (props: Props) => {
  const {text, highlight} = props
  const bem = Util.bemFrom('highlight')

  if (!highlight?.trim()) {
    return <span>{text}</span>
  }
  const parts: JSX.Element[] = []
  let i = 0
  Search.highlight(
    highlight,
    text,
    part => {
      i++
      parts.push(
        <span key={i} className={bem('plain')}>
          {part}
        </span>
      )
    },
    hl => {
      i++
      parts.push(
        <span key={i} className={bem('highlighted')}>
          {hl}
        </span>
      )
    }
  )
  return <span className={bem()}>{parts}</span>
}

export const LimitedHighlight = ({highlight, text}: Props) => {
  const elems: React.ReactNode[] = []

  Search.highlight(
    highlight,
    text,
    (plain, isFirst, isLast) => {
      const isFirstAndLast = isFirst && isLast
      const max = isFirstAndLast ? 100 : 20
      let limitedText = ''
      if (plain.length < max || isFirstAndLast) {
        limitedText = plain
      } else if (isLast) {
        limitedText = `${plain.slice(0, max)}… `
      } else if (isFirst) {
        limitedText = ` …${plain.slice(-max)}`
      } else {
        limitedText = `${plain.slice(0, max / 2)} … ${plain.slice(-max / 2)}`
      }
      elems.push(
        <span key={elems.length} className="whitespace-pre">
          <EmojiText value={limitedText} />
        </span>
      )
    },
    hl => {
      elems.push(
        <span key={elems.length} className="whitespace-pre text-action-default">
          {hl}
        </span>
      )
    }
  )

  return <>{elems}</>
}
